import CustomResponse from '@model/custom-response';

export interface EntityWrapper {
  canonicalEntityClassName: string;
  entity: any;
}

export interface FormField {
  fieldGroupClassName: string;
  template: string;
  fieldGroup: FormGroup[];
}

export interface FormGroup {
  className: string;
  key: string;
  type: string;
  wrappers: string[];
  templateOptions: any;
  validation: any;
}

export interface FormStepGroup {
  formUsageType: string;
  formName: string;
  steps: StepType[];
  formData: Map<string, any>;
  formStepGroupNode: FormStepGroup;
}

export interface MainContext {
  messageProcessError: string;
  messages: Message[];
  flowGroup: string;
  workflowContext: WorkflowContext;
}

export class Message {
  constructor(
    public value: any,
    public messageLevelType: string,
    public isFieldForm?: boolean,
    public key?: string,
    public code?: number
  ) {}

  get formattedValue() {
    //<Arnold> Here I've to test if is an string or a object containing the message
    if (this.value instanceof CustomResponse || this.value instanceof Object) {
      return this.value.message;
    } else {
      return this.value;
    }
  }
}

export interface WorkflowContext {
  nextFlow: boolean;
  lastWorkflow: string;
  nextWorkflow: string;
  workflowCompleted: boolean;
  urlHelper: string;
  validationFacts: Map<string, boolean>;
  cleanContext: boolean;
  formStepGroup: FormStepGroup;
  entityWrapperList: EntityWrapper[];
}

export interface StepType {
  label: string;
  fields: FormField;
}
